module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_4_Hayman@2x.11e701f4a03770282effda669010fcc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_4_Hayman@2x.png
// module id = 751
// module chunks = 0